import { render, staticRenderFns } from "./UpgradePlanTag.vue?vue&type=template&id=6b59c07b&scoped=true"
import script from "./UpgradePlanTag.vue?vue&type=script&lang=ts"
export * from "./UpgradePlanTag.vue?vue&type=script&lang=ts"
import style0 from "./UpgradePlanTag.vue?vue&type=style&index=0&id=6b59c07b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b59c07b",
  null
  
)

export default component.exports